export default function MaterialTechSection() {
  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            소재 기술
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            에어로젤 코팅 섬유를 기반으로 한 혁신적인 기능성 소재
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/f6e4c75f6cbc0b0cd7533416379aa516.jpg"
              alt="에어로젤 코팅 섬유"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-800 mb-8">에어로젤 코팅 섬유</h3>
            <p className="text-base text-gray-600 mb-10 leading-relaxed">
              나노 기술로 개발된 에어로젤을 섬유에 코팅하여 극한의 환경에서도 최적의 보호 성능을 제공합니다. 
              가볍고 얇으면서도 뛰어난 단열 성능을 자랑하는 차세대 소재입니다.
            </p>

            <div className="space-y-6">
              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-emerald-50 rounded-xl flex-shrink-0">
                    <i className="ri-temp-cold-line text-3xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-800 mb-2">초단열</h4>
                    <p className="text-base text-gray-600">
                      극한의 추위에서도 체온을 유지하는 뛰어난 단열 성능. 
                      기존 소재 대비 3배 이상의 보온력을 제공합니다.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-emerald-50 rounded-xl flex-shrink-0">
                    <i className="ri-feather-line text-3xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-800 mb-2">초경량</h4>
                    <p className="text-base text-gray-600">
                      무게 부담 없이 자유로운 움직임을 제공합니다. 
                      장시간 착용해도 피로감이 적어 작업 효율을 높입니다.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 flex items-center justify-center bg-emerald-50 rounded-xl flex-shrink-0">
                    <i className="ri-shield-star-line text-3xl text-emerald-600"></i>
                  </div>
                  <div>
                    <h4 className="text-xl font-bold text-gray-800 mb-2">고기능성</h4>
                    <p className="text-base text-gray-600">
                      방수, 방풍, 투습 기능을 모두 갖춘 다기능 소재. 
                      산업 현장의 다양한 환경에 최적화된 보호 기능을 제공합니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-10 shadow-lg">
          <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">기술 특성</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-50 rounded-full mx-auto mb-4">
                <i className="ri-fire-line text-3xl text-emerald-600"></i>
              </div>
              <h5 className="text-lg font-bold text-gray-800 mb-2">난연성</h5>
              <p className="text-sm text-gray-600">화재 위험으로부터 안전하게 보호</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-50 rounded-full mx-auto mb-4">
                <i className="ri-drop-line text-3xl text-emerald-600"></i>
              </div>
              <h5 className="text-lg font-bold text-gray-800 mb-2">방수성</h5>
              <p className="text-sm text-gray-600">습기와 물로부터 완벽한 차단</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-50 rounded-full mx-auto mb-4">
                <i className="ri-wind-line text-3xl text-emerald-600"></i>
              </div>
              <h5 className="text-lg font-bold text-gray-800 mb-2">투습성</h5>
              <p className="text-sm text-gray-600">쾌적한 착용감 유지</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}